<form [formGroup]="login2FAForm" (submit)="verifyLogin2FA()" novalidate>
  <div class="frame-content flex flex-col w-full gap-4">
    <div class="title text-center">2-Step verification</div>

    <ng-container *ngIf="typeLogin2FA === 'totp'">
      <div class="flex items-center gap-4">
        <img width="36px" src="https://ui.b3networks.com/external/icon/authenticator.jpg" />
        <div>Get code from Authenticator to sign in to your account.</div>
      </div>
    </ng-container>

    <ng-container *ngIf="typeLogin2FA === 'system_generated'">
      <div class="flex items-center gap-4">
        <img src="https://ui.b3networks.com/icons/icon_email.png" />
        <div>An email message with your code has been sent to {{ sensitiveEmail() }}</div>
      </div>
      <a href="javascript:;" *ngIf="!reLoginIndicator" (click)="relogin()">Didn't receive the message?</a>
      <div *ngIf="reLoginIndicator" class="text-center">
        <mat-spinner color="primary" diameter="20"></mat-spinner>
      </div>
    </ng-container>

    <ng-container *ngIf="typeLogin2FA !== 'recovery_key'">
      <mat-form-field>
        <mat-label>Verification code</mat-label>
        <span class="font-[550]" *ngIf="typeLogin2FA === 'system_generated'" matPrefix>
          {{ loginResponse.sanitizedCode }} -&nbsp;
        </span>
        <input
          matInput
          formControlName="otpCodeView"
          placeholder="Verification code"
          (input)="showErrorSummary = false"
          required
        />
        <mat-error *ngIf="typeLogin2FA !== 'recovery_key' && otpCode.invalid">
          {{ getErrorOtpCode() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <ng-container *ngIf="typeLogin2FA === 'recovery_key'">
      <div>
        <span class="font-[550]">Enter your recovery key</span><br />
        <span [class.text-error]="recoveryKey.invalid && recoveryKey.dirty">
          You should change recovery key after sign in to keep it safe.
        </span>
      </div>

      <mat-form-field>
        <mat-label>Recovery key</mat-label>
        <input
          matInput
          formControlName="recoveryKey"
          placeholder="Recovery key"
          (input)="showErrorSummary = false"
          required
        />
        <mat-error *ngIf="typeLogin2FA === 'recovery_key' && recoveryKey.invalid">
          {{ getErrorRecoveryKey() }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <mat-checkbox color="primary" formControlName="trustBrowser">Trust this computer for 30 days</mat-checkbox>

    <div class="noti-summary error" *ngIf="showErrorSummary">{{ error }}</div>

    <button
      mat-raised-button
      type="submit"
      color="primary"
      [loading]="indicator"
      [style.backgroundColor]="
        ((typeLogin2FA === 'recovery_key' && recoveryKey.valid) ||
          (typeLogin2FA !== 'recovery_key' && otpCode.valid)) &&
        !indicator
          ? partner.loginButtonBackground
          : ''
      "
      [disabled]="
        (typeLogin2FA === 'recovery_key' && recoveryKey.invalid) ||
        (typeLogin2FA !== 'recovery_key' && otpCode.invalid) ||
        indicator
      "
    >
      Verify
    </button>

    <p class="text-center">
      <a href="javascript:;" (click)="switchTypeSignIn()">
        {{ typeLogin2FA === 'recovery_key' ? 'Sign in using verification code' : 'Sign in using recovery key' }}
      </a>
    </p>
  </div>
</form>
